import { Box, Text } from "@chakra-ui/react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { darkMode, lightMode } from "../../../theme/config";
import { useColorModeValue } from "../../ui/color-mode";

export const HorizontalBarRepresentation = ({ data, title, color, xAxisDataKey, yAxisDataKey }) => {
    const bgColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    return (
        <Box p={5} shadow="md" borderRadius="lg" width={"100%"} bg={bgColor}>
            <Text fontSize="xl" fontWeight="semibold" p={2}>
                {title}
            </Text>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <XAxis dataKey={xAxisDataKey} axisLine={false} tickLine={false} />
                    <YAxis axisLine={false} tickLine={false} />
                    <Tooltip />
                    <Bar dataKey={yAxisDataKey} fill={color} radius={[4, 4, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};

export const VerticalBarRepresentation = ({ data, title, color, xAxisDataKey, yAxisDataKey }) => {
    const bgColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    return (
        <Box p={5} shadow="md" borderRadius="lg" width={"100%"} bg={bgColor}>
            <Text fontSize="xl" fontWeight="semibold" p={2}>
                {title}
            </Text>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data} layout="vertical">
                    <XAxis type="number" axisLine={false} tickLine={false} />
                    <YAxis dataKey={xAxisDataKey} type="category" axisLine={false} tickLine={false} width={100} />
                    <Tooltip />
                    <Bar dataKey={yAxisDataKey} fill={color} radius={[4, 4, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};
